export default "__VITE_ASSET__BjGGSWRn__"